import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import ConfigService from "../../../services/configuracion/ConfigService";
import ButtonLink from "../../generico/ButtonLink";
import history from "../login/history";
import Popup from "react-popup";
import HabilitarAhorroProgramadoService from "../../../services/autogestion/HabilitarAhorroProgramadoService";
import { trackPromise } from "react-promise-tracker";
import resumenSocioService from "../../../services/resumenGeneral/resumenSocioService";

const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

const MOVIMIENTO_PLAZO_FIJO = 63;

export default class PlazoFijo extends Component {
  constructor(props) {
    super(props);
  }


  componentDidMount() {


  }

  getColumnDetalle() {
    return [
      {
        name: "Cuenta",
        selector: row => row.cuenta
      },
      {
        name: "Descripción",
        selector: row => row.descripcion,
        width: "250px"
      },
      {
        name: "Moneda",
        selector: row => row.moneda,
      },
      {
        name: "Capital",
        selector: row => row.saldoTotal,
        right: "true"
      },
      {
        name: "Inicio",
        selector: row => row.fechaApertura,
      },
      {
        name: "Vencimiento",
        selector: row => row.fechaVencimiento
      },
      {
        name: "Etiqueta",
        selector: row => row.etiqueta ? row.etiqueta.toUpperCase() : 'CUENTA DE AHORRO',
      },
      {
        name: "TipoAhorro",
        selector: row => row.tipoAhorro,
        omit: true // ocultar columna en react-data-table-component
      },
      {
        cell: (row) => (

          <div className="flex flex-col space-y-2 p-2">
            <ButtonLink
              className="btn btn-cu-primary btn-sm"
              param={row}
              url={ConfigService.getPathById(MOVIMIENTO_PLAZO_FIJO)?.url}
              onClick={this.movimientos}>
              <FontAwesomeIcon icon={faEye} /> Ver Movimientos
            </ButtonLink>
            {row.numeroLegajo == 900059 &&
              <div className="dropdown dropdownPi">
                <button className="btn btn-cu-primary dropdown-toggle" type="button" id="dropdownMenuBut  hton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Detalles
                </button><br />

                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {/* <span className="dropdown-item" onClick={() => { this.descargar('CONTRATO',row.cuenta) }}>Ver contrato</span>
                <span className="dropdown-item" onClick={() => { this.descargar('LIQUIDACION',row.cuenta) }}>Ver Liquidacion</span>
                <span className="dropdown-item" onClick={() => { this.descargar('SOLICITUD',row.idSolicitud) }}>Ver Solicitud</span> */}
                  <button className="dropdown-item" onClick={() => { this.descargarContrato(row) }}>Ver Contrato</button>
                  <a className="dropdown-item" onClick={() => {
                    this.callPopupAndSetCuenta('Etiqueta de Cuenta', row)
                  }} href="#">Modificar Etiqueta</a>

                </div>

              </div>
            }
          </div>
        ),
        width: "250px"
      }

    ];
  }

  notifiPopupWithInput(titulo, row) {
    let inputValue = '';
    Popup.create({
      title: titulo,
      content: (
        <div className="modal-body align-items-center">
          <p style={{ fontFamily: 'Montserrat-Medium', fontSize: '15px' }}>
            Introducir el nombre de su cuenta:
          </p>
          <input
            type="text"
            className="form-control input-box"
            placeholder={'Introduzca'}
            onChange={(e) => {
              inputValue = e.target.value;
            }}
          />
        </div>
      ),
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: () => {
              this.changeEtiqueta(row?.cuenta, inputValue);
              Popup.close();
            },
          },
          {
            text: 'Cancelar',
            className: "secundary",
            action: () => { Popup.close() }
          }
        ],
      },
    });
  }

  changeEtiqueta (numeroCuenta , newEtiqueta){
    let body = {
      idAhorro : numeroCuenta,
      etiqueta : newEtiqueta
    }
    trackPromise(
      resumenSocioService.modificarEtiqueta(body)
      .then( ({status , data }) =>{
        if( status === 200 ){
          if( data.codigo === 0 ){
            this.props.plazoFijo.forEach(element => {
              if( element.cuenta === numeroCuenta ){
                this.setState({ nombreCuenta : newEtiqueta });
                element.etiqueta = newEtiqueta;
              }
            });
            this.forceUpdate();
          }else{
            Popup.queue( this.notifiPopup( 'Error' , data.mensajeServidor ) );
            console.error('data.codigo distinto de 0');
          }
        }else{
          console.error('status distinto a 200');
          Popup.queue( this.notifiPopup( 'Error' , 'Ha ocurrido un error al momento de actualizar el nombre de la cuenta. Por favor intente más tarde.' ) );
        }
      })
    )
  }



  callPopupAndSetCuenta(titulo, row) {
    this.setState({ cuenta: row?.ahorro, nombreCuenta: row?.etiqueta });
    this.notifiPopupWithInput(titulo, row);
  }

  movimientos = (url, row) => {
    sessionStorage.setItem("AH", row.cuenta);
    sessionStorage.setItem("tipo", row.tipoAhorro);
    history.push(url);
    window.location.reload();
  }



  descargarContrato = async (row) => {

    await trackPromise(
      // HabilitarAhorroProgramadoService.descargarContratoMeta(this.props.idAhorro)
      HabilitarAhorroProgramadoService.descargarContratoMeta(row.cuenta)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  render() {
    return (
      <DataTable
        noHeader={true}
        pagination={true}
        columns={this.getColumnDetalle()}
        data={this.props.plazoFijo}
        paginationComponentOptions={paginationOptions}
        noDataComponent="no hay registros para mostrar"
        responsive={true}
        striped={true} />
    );
  }
}